// extracted by mini-css-extract-plugin
export default {"root":"chat_body___root___fa2f1486","tooltip":"chat_body___tooltip___ba47bb73"};